export default __webpack_public_path__ + "static/media/test-avatar3.bab1fc57.jpg";